import React from 'react';

export const GroupStakeholderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="23"
    viewBox="0 0 22 23"
    fill="none"
  >
    <rect
      x="0.423077"
      y="0.923077"
      width="21.1538"
      height="21.1538"
      rx="6.34615"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8158 15.5373L14.8158 15.5373C14.0646 16.5964 12.8053 17.1975 10.8711 17.1975C8.93642 17.1975 7.67862 16.5962 6.9298 15.5373L6.92979 15.5373C6.82569 15.3901 6.76929 15.2131 6.76929 15.0309V14.4574C6.76929 14.1444 7.01945 13.9015 7.31467 13.9015H14.4316C14.7268 13.9015 14.977 14.1443 14.977 14.4574V15.03C14.977 15.2126 14.9203 15.3899 14.8158 15.5373ZM10.8711 6.4231C12.1065 6.4231 13.1188 7.43388 13.1188 8.69417C13.1188 9.95446 12.1065 10.9652 10.8711 10.9652C9.63573 10.9652 8.62341 9.95447 8.62341 8.69417C8.62341 7.43388 9.63572 6.4231 10.8711 6.4231Z"
      fill="#27B0E0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.05385 15.6903C5.96792 15.4825 5.92296 15.2585 5.92296 15.0309V14.4574C5.92296 13.683 6.54596 13.0553 7.31449 13.0553H10.1229C10.0161 12.6466 9.64441 12.3451 9.20231 12.3451H4.336C3.81051 12.3451 3.38452 12.7711 3.38452 13.2967V13.686C3.38452 13.928 3.46 14.1641 3.60045 14.3612C4.14055 15.1194 4.96496 15.5608 6.05385 15.6903ZM7.95962 7.63674C7.62021 7.40484 7.20982 7.26923 6.76776 7.26923C5.59941 7.26923 4.6523 8.21649 4.6523 9.38499C4.6523 10.5535 5.59941 11.5008 6.76776 11.5008C7.4613 11.5008 8.07689 11.167 8.46268 10.6512C8.03386 10.1162 7.77707 9.4354 7.77707 8.69415C7.77707 8.32295 7.84147 7.96691 7.95962 7.63674Z"
      fill="#27B0E0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.823 14.4574C15.823 13.683 15.2 13.0553 14.4315 13.0553H11.877C11.9838 12.6466 12.3555 12.3451 12.7976 12.3451H17.6639C18.1893 12.3451 18.6153 12.7711 18.6153 13.2967V13.6853C18.6153 13.928 18.5395 14.1645 18.3984 14.3619C17.8145 15.1792 16.9005 15.6283 15.6812 15.7151C15.7742 15.5002 15.823 15.267 15.823 15.03V14.4574ZM13.4134 10.4709C13.783 11.0878 14.4579 11.5008 15.2293 11.5008C16.3976 11.5008 17.3448 10.5535 17.3448 9.38499C17.3448 8.21649 16.3976 7.26923 15.2293 7.26923C14.6947 7.26923 14.2065 7.46753 13.8341 7.79461C13.9191 8.07942 13.9648 8.3814 13.9648 8.69414C13.9648 9.35448 13.7611 9.96687 13.4134 10.4709Z"
      fill="#27B0E0"
    />
    <rect
      x="0.423077"
      y="0.923077"
      width="21.1538"
      height="21.1538"
      rx="6.34615"
      stroke="#27B0E0"
      strokeWidth="0.846154"
    />
  </svg>
);
